var typeAlert = ["error", "warning", "success", "info"];
var tailleAlert = ["sm", "md"];
export var AlerteDefaultProps = {
    type: 'info',
    taille: 'md',
    titreAs: 'h3'
};
